import { Injectable } from '@angular/core';
import { IIDApparatoSplitterStore } from './iidApparatoSplitter.store';
import { IID_APPARATO_SPLITTER } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDApparatoSplitterQuery } from './iidApparatoSplitter.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.APPARATO_SPLITTER)
export class IIDApparatoSplitterService extends CrudService<IID_APPARATO_SPLITTER, IIDApparatoSplitterStore, IIDApparatoSplitterQuery> {
  constructor(
    protected store: IIDApparatoSplitterStore,
    public query: IIDApparatoSplitterQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_APPARATO_SPLITTER,
      store,
      query,
      actionService,
      updateStrategy
    );
  }
}
